/** Presentation for a 120-second active arcade run. Time advances through visual
 * effects; explicit pause, permission loss and hidden surfaces stop it. Board
 * continuation waits for 900ms of visible, settled celebration. No RAF, random
 * state, scoring or network access belongs to this owner. */
export function createTimedRunPresentation(ctx, hud, { onExpire, onContinue, onTimer }) {
  const counter = ctx.e('strong', 'game-arcade-clock');
  counter.setAttribute('role', 'timer');
  counter.setAttribute('aria-live', 'off');
  counter.hidden = true;
  hud.append(counter);
  let elapsed = 0,
    last = null,
    hold = 0,
    expired = false,
    disposed = false;
  function paint(show = !counter.hidden) {
    counter.hidden = !show;
    const seconds = Math.max(0, Math.ceil((120000 - elapsed) / 1000));
    const minutes = Math.floor(seconds / 60);
    counter.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
    counter.dataset.warning = String(seconds <= 15 && seconds > 0);
    counter.dataset.expired = String(expired);
    counter.setAttribute('aria-label', `${minutes} minutes ${seconds % 60} seconds remaining`);
  }
  return {
    paint,
    reset(now = null) {
      elapsed = 0;
      last = now;
      hold = 0;
      expired = false;
      paint();
    },
    suspend() {
      last = null;
    },
    tick(now, { active, betweenBoards, ready, capped = false }) {
      if (disposed || expired) return;
      const delta = active && last !== null ? Math.max(0, now - last) : 0;
      last = active ? now : null;
      if (!active) return;
      elapsed = Math.min(120000, elapsed + delta);
      onTimer(elapsed);
      paint(true);
      if (elapsed >= 120000) {
        expired = true;
        paint(true);
        onExpire();
        return;
      }
      if (!betweenBoards || capped) hold = 0;
      else if (ready) {
        hold += delta;
        if (hold >= 900) {
          hold = 0;
          onContinue();
          return true;
        }
      }
    },
    dispose() {
      disposed = true;
      last = null;
      counter.remove();
    },
  };
}
